// Copyright (c) StrangeBee 2023

import { UserOutput } from 'thehive-sdk';

export const findUser = (login: string, currentUsers: UserOutput[] | undefined): UserOutput | undefined =>
    currentUsers?.find(({ login: userLogin }) => userLogin === login);
